import React from 'react';
import './UserForgotPassword.scss';
import { NavLink } from "react-router-dom";
import request from '../../utils/agent';

export default class UserForgotPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errorMessage: null,
            successMessage: null
        };
    }

    resetPassword = () => {
        request.post('/api/user/resetpassword')
            .send({
                email: this.refs.userEmail.value
            })
            .then(resp => {
                //console.log(resp);
                this.setState({
                    successMessage: "A reset email will be sent to you if we have a user for that email."
                });
            }) 
            .catch(err => {
                console.log(err);
                this.setState({
                    errorMessage: "An error occurred, please try again."
                });
            });
    }

    render() {
        return(
            <section className="site-centered">
                <div className="row justify-content-md-center">
                    <div id="login-form" className="col-sm-6 col-sm-offset-3 col-xs-12">
                        <div className="panel panel-default panel-logged-out">
                            <div className="panel-heading">
                                <h3 className="panel-title">Forgot Password</h3>
                            </div>
                            <div className="panel-body">
                                {this.state.errorMessage && 
                                    <div className="alert alert-danger">
                                        { this.state.errorMessage }
                                    </div>
                                }
                                {this.state.successMessage && 
                                    <div className="alert alert-info">
                                        {this.state.successMessage}
                                    </div>
                                }
                                <div className="form-group">
                                    <input ref="userEmail" type="email" name="email" className="form-control" placeholder="Email" />
                                </div>

                                <button onClick={this.resetPassword} className="btn btn-default btn-primary">Reset</button>
                                <NavLink className="btn btn-default btn-primary btn-gray" to="/login">Back to Log In</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/UserForgotPassword/index.js